import {
  FirmSize,
  EmploymentType,
  AnnualProjectCapacity,
  ReferenceProjectType,
  TotalRevenue,
  ReferenceType,
  DesignerFileType,
  DesignBoardType,
  ColorFamily,
  GreatFor,
  Textures,
  Finishes,
  Patterns,
  ProjectStyles,
  ProjectCategory,
  SpecialRequirements,
  BudgetRange,
  SquareFootage,
  ProjectDuration,
  AgeRange,
} from "../__generated__/types";

// labels and options for enums/inputs
export const firmSizeLabels = {
  [FirmSize.Indepenedent]: "Independent",
  [FirmSize.Two]: "2",
  [FirmSize.ThreeToFive]: "3-5",
  [FirmSize.SixAndUp]: "6+",
};

export const employmentTypeLabels = {
  [EmploymentType.ForSomeone]: "For Someone",
  [EmploymentType.SelfEmployed]: "Self Employed",
};

export const AnnualProjectCapacityLabels = {
  [AnnualProjectCapacity.OneToThree]: "1-3",
  [AnnualProjectCapacity.FourToSix]: "4-6",
  [AnnualProjectCapacity.SevenToTen]: "7-10",
  [AnnualProjectCapacity.ElevenAndUp]: "11+",
};

export const ReferenceProjectTypeLabels = {
  [ReferenceProjectType.AntiqueSelection]: "Antique Selection",
  [ReferenceProjectType.ArtSelection]: "Art Selection",
  [ReferenceProjectType.BasementDesign]: "Basement Design",
  [ReferenceProjectType.PrimaryBathroomDesign]: "Bathroom Design (Primary)",
  [ReferenceProjectType.PrimaryBedroomDesign]: "Bedroom Design (Primary)",
  [ReferenceProjectType.ColorConsulting]: "Color Consulting",
  [ReferenceProjectType.DiningRoomDesign]: "Dining Room Design",
  [ReferenceProjectType.EntryDesign]: "Entry Design",
  [ReferenceProjectType.EventAndHolidayDecor]: "Event/Holiday Decor",
  [ReferenceProjectType.FullHomeDesign]: "Full Home Design",
  [ReferenceProjectType.FurnitureSelection]: "Furniture Selection",
  [ReferenceProjectType.GuestBedroomDesign]: "Guest Bedroom Design",
  [ReferenceProjectType.HomeStaging]: "Home Staging",
  [ReferenceProjectType.KidsBedroom]: "Kids Bedroom Design",
  [ReferenceProjectType.KitchenDesign]: "Kitchen Design",
  [ReferenceProjectType.LightingDesign]: "Lighting Design",
  [ReferenceProjectType.LivingRoomDesign]: "Living Room Design",
  [ReferenceProjectType.MudroomDesign]: "Mudroom Design",
  [ReferenceProjectType.OutdoorLivingSpace]: "Outdoor Living Space",
  [ReferenceProjectType.SpacePlanning]: "Space Planning",
  [ReferenceProjectType.Other]: "Other",
};

export const TotalRevenueLabels = {
  [TotalRevenue.TwentyFiveToFifty]: "$25,000 - $50,000",
  [TotalRevenue.FiftyToSeventyFive]: "$50,000 - $75,000",
  [TotalRevenue.SeventyFiveToOneHundredFifty]: "$75,000 - $150,000",
  [TotalRevenue.OneHundredFiftyToTwoHundred]: "$150,000 - $200,000",
  [TotalRevenue.TwoHundredAndUp]: "$200,000+",
};

export const ReferenceTypeLabels = {
  ...ReferenceType,
  [ReferenceType.ProductManufacturer]: "Product Manufacturer/Retailer",
  [ReferenceType.ServicesVendor]: "Services Vendor",
};

export const DesignerFileTypeLabels = {
  [DesignerFileType.BeforeAndAfter]: "Before and After",
  [DesignerFileType.DesignBoard]: "Design Board",
  [DesignerFileType.ProjectProfile]: "Project Profile",
};

export const DesignBoardTypeLabels = {
  [DesignBoardType.Color]: "Color Board",
  [DesignBoardType.Mood]: "Mood Board",
  [DesignBoardType.PatternPlay]: "Pattern Play",
  [DesignBoardType.StyleFusion]: "Style Fusion",
  [DesignBoardType.TextureAndFinish]: "Texture and Finish",
};

export const greatForLabels = {
  [GreatFor.AllSpaces]: "All Spaces",
  [GreatFor.BrightSpaces]: "Bright Spaces",
  [GreatFor.DarkSpaces]: "Dark Spaces",
  [GreatFor.LargeSpaces]: "Large Spaces",
  [GreatFor.RoomsWithHighCeilings]: "Rooms with High Ceilings",
  [GreatFor.RoomsWithLowCeilings]: "Rooms with Low Ceilings",
  [GreatFor.SmallSpaces]: "Small Spaces",
};

export const ColorFamilyLabels = ColorFamily;
export const textureLabels = Textures;
export const finishLabels = {
  [Finishes.Carpet]: "Carpet",
  [Finishes.DecorativeStone]: "Decorative Stone",
  [Finishes.Hardwood]: "Hardwood",
  [Finishes.Marble]: "Marble",
  [Finishes.Metallic]: "Metallic",
  [Finishes.Paint]: "Paint",
  [Finishes.Tile]: "Tile",
  [Finishes.Vinyl]: "Vinyl",
  [Finishes.Wallpaper]: "Wallpaper",
  [Finishes.Wood]: "Wood",
};

export const patternLabels = {
  [Patterns.Abstract]: "Abstract",
  [Patterns.AnimalPrint]: "Animal Print",
  [Patterns.Argyle]: "Argyle",
  [Patterns.Basketweave]: "Basketweave",
  [Patterns.Chevron]: "Chevron",
  [Patterns.Damask]: "Damask",
  [Patterns.Diamond]: "Diamond",
  [Patterns.FleurDeLis]: "Fleur DeLis",
  [Patterns.Floral]: "Floral",
  [Patterns.Fret]: "Fret",
  [Patterns.Geometric]: "Geometric",
  [Patterns.Gingham]: "Gingham",
  [Patterns.Graph]: "Graph",
  [Patterns.GreekKey]: "GreekKey",
  [Patterns.Harlequin]: "Harlequin",
  [Patterns.Herringbone]: "Herringbone",
  [Patterns.Houndstooth]: "Houndstooth",
  [Patterns.Ikat]: "Ikat",
  [Patterns.Kilm]: "Kilm",
  [Patterns.Lattice]: "Lattice",
  [Patterns.Madras]: "Madras",
  [Patterns.Navajo]: "Navajo",
  [Patterns.Ogee]: "Ogee",
  [Patterns.Ombre]: "Ombre",
  [Patterns.Paisley]: "Paisley",
  [Patterns.Plaid]: "Plaid",
  [Patterns.PolkaDot]: "PolkaDot",
  [Patterns.Scroll]: "Scroll",
  [Patterns.SerpentineStripes]: "Serpentine Stripes",
  [Patterns.ShepherdsCheck]: "Shepherds Check",
  [Patterns.Stripes]: "Stripes",
  [Patterns.Suzaani]: "Suzaani",
  [Patterns.Tartan]: "Tartan",
  [Patterns.Tattersall]: "Tattersall",
  [Patterns.Tribal]: "Tribal",
};

export const projectStyleLabels = {
  [ProjectStyles.ArtDeco]: "Art Deco",
  [ProjectStyles.Bohemian]: "Bohemian",
  [ProjectStyles.Coastal]: "Coastal",
  [ProjectStyles.Contemporary]: "Contemporary",
  [ProjectStyles.Eclectic]: "Eclectic",
  [ProjectStyles.Farmhouse]: "Farmhouse",
  [ProjectStyles.FrenchCountry]: "French Country",
  [ProjectStyles.HollywoodRegency]: "Hollywood Regency",
  [ProjectStyles.Industrial]: "Industrial",
  [ProjectStyles.Maximalism]: "Maximalism",
  [ProjectStyles.MidCentury]: "Mid-Century",
  [ProjectStyles.Minimalist]: "Minimalist",
  [ProjectStyles.Modern]: "Modern",
  [ProjectStyles.ModernFarmhouse]: "Modern Farmhouse",
  [ProjectStyles.Rustic]: "Rustic",
  [ProjectStyles.Scandinavian]: "Scandinavian",
  [ProjectStyles.ShabbyChic]: "Shabby Chic",
  [ProjectStyles.Traditional]: "Traditional",
  [ProjectStyles.Transitional]: "Transitional",
};

export const bugetRangeLabels: Record<BudgetRange, string> = {
  [BudgetRange.Under_3000]: "Up to 3,000",
  [BudgetRange.UpToThreeK]: "Up to 3,000",
  [BudgetRange.ThreeKToFiveK]: "3,001 - 5,000",
  [BudgetRange.From_3001To_5Hundred]: "3,001 - 5,000",
  [BudgetRange.FiveKToTenK]: "5,001 - 10,000",
  [BudgetRange.From_5001To_10Thousand]: "5,001 - 10,000",
  [BudgetRange.TenKToFifteenK]: "10,001 - 15,000",
  [BudgetRange.From_10001To_15Thousand]: "10,001 - 15,000",
  [BudgetRange.FifteenKToTwentyK]: "15,001 - 20,000",
  [BudgetRange.From_15001To_20Thousand]: "15,001 - 20,000",
  [BudgetRange.TwentyKToThirtyK]: "20,001 - 30,000",
  [BudgetRange.From_20001To_25Thousand]: "20,001 - 25,000",
  [BudgetRange.From_25001To_30Thousand]: "25,001 - 30,000",
  [BudgetRange.ThirtyKToFortyK]: "30,001 - 40,000",
  [BudgetRange.From_30001To_35Thousand]: "30,001 - 35,000",
  [BudgetRange.From_35001To_40Thousand]: "35,001 - 40,000",
  [BudgetRange.FortyKToFiftyK]: "40,001 - 50,000",
  [BudgetRange.From_40001To_45Thousand]: "40,001 - 45,000",
  [BudgetRange.From_45001To_50Thousand]: "45,001 - 50,000",
  [BudgetRange.FiftyKToSeventyFiveK]: "50,001 - 75,000",
  [BudgetRange.SeventyFiveKToOneHundredK]: "75,000 - 100,000",
  [BudgetRange.OneHundredKAndUp]: "100,000+",
};

// Support both legacy space-delimited values and new camel-cased values
export const specialRequirementsLabels: Record<string, string> = {
  AccessibilityForDisabilities: "Accessibility for Disabilities",
  "Accessibility For Disabilities": "Accessibility for Disabilities",
  ArtIntegration: "Art Integration",
  "Art Integration": "Art Integration",
  CustomStorageSolutions: "Custom Storage Solutions",
  "Custom Storage Solutions": "Custom Storage Solutions",
  EnvironmentallySustainableMaterials: "Environmentally Sustainable Materials",
  "Environmentally Sustainable Materials": "Environmentally Sustainable Materials",
  FengShui: "Feng Shui",
  "Feng Shui": "Feng Shui",
  HistoricalPreservationConsideration: "Historical Preservation Consideration",
  "Historical Preservation Consideration": "Historical Preservation Consideration",
  HomeGym: "Home Gym",
  "Home Gym": "Home Gym",
  OutdoorLivingConnections: "Outdoor Living Connections",
  "Outdoor Living Connections": "Outdoor Living Connections",
  PetFriendlyDesign: "Pet Friendly Design",
  "Pet Friendly Design": "Pet Friendly Design",
  SmartHomeIntegration: "Smart Home Integration",
  "Smart Home Integration": "Smart Home Integration",
  SpecializedVentilationSystems: "Specialized Ventilation Systems",
  "Specialized Ventilation Systems": "Specialized Ventilation Systems",
  SpecificAcousticTreatments: "Specific Acoustic Treatments",
  "Specific Acoustic Treatments": "Specific Acoustic Treatments",
  UniqueLightingEffects: "Unique Lighting Effects",
  "Unique Lighting Effects": "Unique Lighting Effects",
  WineCellar: "Wine Cellar",
  "Wine Cellar": "Wine Cellar",
  Other: "Other",
  None: "None",
  NotApplicable: "N/A",
};

export const formatSpecialRequirementLabel = (
  value?: string | null
): string => {
  if (!value) return "";

  const directMatch = specialRequirementsLabels[value];
  if (directMatch) return directMatch;

  const spaced = value
    .replace(/([a-z])([A-Z])/g, "$1 $2")
    .replace(/_/g, " ")
    .replace(/\s+/g, " ")
    .trim();

  if (!spaced) return value;

  return spaced.charAt(0).toUpperCase() + spaced.slice(1);
};

export const projectCategoryLabels = {
  [ProjectCategory.AntiqueSelection]: "Antique Selection",
  [ProjectCategory.ArtSelection]: "Art Selection",
  [ProjectCategory.BasementDesign]: "Basement Design",
  [ProjectCategory.ColorConsulting]: "Color Consulting",
  [ProjectCategory.ConstructionRemodel]: "Construction/Remodel",
  [ProjectCategory.DiningRoomDesign]: "Dining Room Design",
  [ProjectCategory.EntryDesign]: "Entry Design",
  [ProjectCategory.EventAndHolidayDecor]: "Event/Holiday Decor",
  [ProjectCategory.FamilyRoom]: "Living Room",
  [ProjectCategory.FullHomeDesign]: "Full Home Design",
  [ProjectCategory.FurnitureSelection]: "Furniture Selection",
  [ProjectCategory.GuestBedroomDesign]: "Guest Bedroom Design",
  [ProjectCategory.HomeOffice]: "Home Office",
  [ProjectCategory.HomeStaging]: "Home Staging",
  [ProjectCategory.KidsBedroom]: "Kids Bedroom Design",
  [ProjectCategory.KitchenDesign]: "Kitchen Design",
  [ProjectCategory.LightingDesign]: "Lighting Design",
  [ProjectCategory.LivingRoomDesign]: "Living Room Design",
  [ProjectCategory.MudroomDesign]: "Mudroom Design",
  [ProjectCategory.Other]: "Other",
  [ProjectCategory.OtherBathroomDesign]: "Other Bathroom Design",
  [ProjectCategory.OutdoorSpaceDesign]: "Outdoor Space Design",
  [ProjectCategory.PrimaryBathroomDesign]: "Primary Bathroom Design",
  [ProjectCategory.PrimaryBedroomDesign]: "Primary Bedroom Design",
  [ProjectCategory.SpacePlanning]: "Space Planning",
  [ProjectCategory.ProjectManagementDesign]: "Project Management Design",
};

export const squareFootageLabels = {
  [SquareFootage.UnderTwelveHundred]: "Under 1200",
  [SquareFootage.TwelveHundredToTwoThousand]: "1200 - 2000",
  [SquareFootage.TwoThousandToThreeThousand]: "2000 - 3000",
  [SquareFootage.OverThreeThousand]: "Over 3000",
};

export const projectDurationLabels = {
  [ProjectDuration.OneMonth]: "1 Month",
  [ProjectDuration.TwoMonths]: "2 Months",
  [ProjectDuration.ThreeMonths]: "3 Months",
  [ProjectDuration.FourToSixMonths]: "4 - 6 Months",
  [ProjectDuration.SeventToTwelveMonths]: "7 - 12 Months",
  [ProjectDuration.MoreThanAYear]: "Over 12 Months",
};

export const ageRangeLabels = {
  [AgeRange.UnderTwentyFive]: "Under 25",
  [AgeRange.TwentyFiveToThirtyFive]: "25-35",
  [AgeRange.ThirtyFiveToFortyFive]: "35-45",
  [AgeRange.FortyFiveToFiftyFive]: "45-55",
  [AgeRange.FiftyFiveToSixtyFive]: "55-65",
  [AgeRange.SixtyFiveAndUp]: "65+",
};

const getValueLabelPairs = <T>(labels: Record<string, T>) => {
  return Object.keys(labels).map((key) => ({
    value: key,
    label: labels[key as keyof typeof labels],
  }));
};

export const FirmSizeOptions = getValueLabelPairs(firmSizeLabels);
export const EmploymentTypeOptions = getValueLabelPairs(employmentTypeLabels);
export const AnnualProjectCapacityOptions = getValueLabelPairs(
  AnnualProjectCapacityLabels
);
export const ReferenceProjectTypeOptions = getValueLabelPairs(
  ReferenceProjectTypeLabels
);
export const TotalRevenueOptions = getValueLabelPairs(TotalRevenueLabels);
export const ReferenceTypeOptions = getValueLabelPairs(ReferenceTypeLabels);
export const designerFileTypeOptions = getValueLabelPairs(
  DesignerFileTypeLabels
);
export const designBoardTypeOptions = getValueLabelPairs(DesignBoardTypeLabels);
export const colorFamilyOptions = getValueLabelPairs(ColorFamilyLabels);
export const greatForOptions = getValueLabelPairs(greatForLabels);
export const textureOptions = getValueLabelPairs(textureLabels);
export const finishOptions = getValueLabelPairs(finishLabels);
export const patternOptions = getValueLabelPairs(patternLabels);
export const projectStyleOptions = getValueLabelPairs(projectStyleLabels);
export const projectCategoryOptions = getValueLabelPairs(projectCategoryLabels);
// Get special requirements options from canonical enum values (ordered as defined)
export const specialRequirementsOptions = (
  Object.values(SpecialRequirements) as SpecialRequirements[]
)
  .filter((value) => value !== SpecialRequirements.NotApplicable)
  .map((value) => ({
    value,
    label:
      specialRequirementsLabels[value] ?? formatSpecialRequirementLabel(value),
  }));
export const budgetRangeOptions = getValueLabelPairs(bugetRangeLabels);
export const squareFootageOptions = getValueLabelPairs(squareFootageLabels);
export const projectDurationOptions = getValueLabelPairs(projectDurationLabels);
